/**
 * Liste des liens externes pour l'assurance maladie
 */
export const externalLinks = {
	proSanteLinks: [
		{ name: 'Chirurgien-dentiste', url: '/chirurgien-dentiste' },
		{ name: 'Établissement', url: '/etablissement' },
		{ name: 'Exercice coordonné', url: '/exercice-coordonne'	},
		{ name: 'Infirmier', url: '/infirmier' },
		{ name: 'Laboratoire d\'analyses médicales', url: '/laboratoire-danalyses-medicales' },
		{ name: 'Masseur kinésithérapeute',	url: '/masseur-kinesitherapeute' },
		{ name: 'Médecin', url: '/medecin' },
		{ name: 'Orthophoniste', url: '/orthophoniste' },
		{ name: 'Orthoptiste', url: '/orthoptiste' },
		{ name: 'Pédicure-podologue', url: '/pedicure-podologue' },
		{ name: 'Pharmacien', url: '/pharmacien' },
		{ name: 'Professionnel de la LPP', url: '/professionnel-de-la-lpp' },
		{ name: 'Psychologue', url: '/psychologue' },
		{ name: 'Sage-femme', url: '/sage-femme' },
		{ name: 'Taxi conventionné', url: '/taxi-conventionne' },
		{ name: 'Transporteur sanitaire', url: '/transporteur-sanitaire' }
	],
	assuranceMaladieLinks: [
		{ name: 'Qui sommmes-nous ?', url: '/qui-sommes-nous' },
		{ name: 'Carrières', url: '/carrieres' },
		{ name: 'Études et données', url: '/etudes-et-donnees' },
		{ name: 'Presse', url: '/presse' }
	]
};
